<div class="row mt-2">
  <div class="col-lg-6 col-12 d-flex justify-content-start">
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="col-lg-6 col-12 d-flex justify-content-end">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
<div class="row mt-4">
  <div class="col-12 d-flex">
    <div class="flex-grow-1"></div>
    <div>
      <button class="btn btn-danger"
              (click)="cancel()">{{'i18n.domain.reports.footer.discard' | translate}}</button>
      <button class="btn btn-primary ms-2"
              (click)="openSaveDialog()">{{'i18n.domain.reports.footer.export' | translate}}</button>
    </div>
  </div>
</div>


<ejs-dialog #saveDialog
            [isModal]="true"
            [showCloseIcon]="true"
            (close)="closeSave()"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.reports.footer.save-dialog.title' | translate}}
  </ng-template>
  <ng-template #content>
    <form [formGroup]="saveForm">
      <div class="form-row row">
        <div class="col-12">
          <label class="d-block control-label">{{'i18n.domain.reports.footer.save-dialog.persistence.label' | translate}}</label>
          <app-yes-no-group-button id="saveReport"
                                   formControlName="saveReport"
                                   yesLabel="i18n.domain.reports.footer.save-dialog.persistence.persistent"
                                   noLabel="i18n.domain.reports.footer.save-dialog.persistence.temporary"></app-yes-no-group-button>
        </div>
      </div>
      @if (!hideFileTypeSelector) {
        <div class="form-row row mt-2">
          <div class="col-12">
            <label class="d-block control-label">{{'i18n.domain.reports.footer.save-dialog.file-type.label' | translate}}</label>
            <app-button-group [fieldsEnum]="ReportFileType"
                              [translateKey]="'i18n.domain.reports.footer.save-dialog.file-type.'"
                              formControlName="exportType"></app-button-group>
          </div>
        </div>
      }
    </form>
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2"
            (click)="closeSave()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary"
            [disabled]="!saveForm.valid"
            (click)="saveReport()">
      {{'i18n.shared.save' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
